import constants from 'constants/index'

const stepChipColor = (step, concluded, classes) => {
  const { AVALIATION_ENUM, LESSONS_LEARNED_ENUM } = constants.incidentManegement

  if (step === LESSONS_LEARNED_ENUM && concluded) {
    return classes.stepGreen
  }

  if (step === AVALIATION_ENUM) {
    return classes.stepLightBlue
  }

  return classes.stepOrange
}

export default stepChipColor
